import React from 'react';
import NotificationDate from './NotificationDate';

const NotificationContainer = ({ item, children, onClick }) => {
  const { creationTime, isVisualized } = item;

  let className = 'notification-item';

  if (typeof onClick === 'function') {
    className += ' gx-pointer';
  }

  if (!isVisualized) {
    className += ' not-visualized';
  }

  return (
    <div
      className={className}
      onClick={onClick}
      onKeyDown={() => {}}
      role="button"
      tabIndex="0"
    >
      {children}
      <NotificationDate date={creationTime} />
    </div>
  );
};

export default NotificationContainer;
